// extracted by mini-css-extract-plugin
module.exports = {"oauth_button":"GoogleButton_oauth_button__zYHmQ","waveHidden":"GoogleButton_waveHidden__Ovvib","wave":"GoogleButton_wave__FuaOy"};